import Image from "next/image";
import { useIntl } from "react-intl";
import Link from "next/link";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { CtaButton } from "@/components/common/ctaButton/CtaButton";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./MovingInformationBlock.module.scss";

export type MovingInformationBlockProps = {
  title: string;
  description: string;
  image: StrapiEntity<StrapiImage>;
  linkURL: string;
};

export const MovingInformationBlock = ({
  title,
  description,
  image,
  linkURL,
}: MovingInformationBlockProps) => {
  const strapiImage = formatStrapiEntity(image);
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <Image
          src={addBasePathToStrapiMedia(strapiImage)}
          objectFit="contain"
          objectPosition="center"
          alt={strapiImage.alternativeText ?? ""}
          layout="fill"
        />
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={injectPurifiedHTML(
            removeEmptyRel(description)
          )}
        />
        <Link href={linkURL}>
          <a>
            <CtaButton label={intl.formatMessage({ id: "discoverLabel" })} />
          </a>
        </Link>
      </div>
    </div>
  );
};
